import { render, staticRenderFns } from "./ShadowProperty.vue?vue&type=template&id=4762d507&"
import script from "./ShadowProperty.vue?vue&type=script&lang=js&"
export * from "./ShadowProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports